import SocialSharingButtons from './SocialSharingButtons'

export default SocialSharingButtons
// eslint-disable-next-line import/export
export * from './SocialSharingButtons'
